export default "__VITE_ASSET__596e246e__"